import { FC } from 'react';

import { HotGappersContentProps } from '../../HotGappers.types';
import HotGappersList from '../HotGappersList/HotGappersList';
import MarketRegularHoursTimer from '../MarketRegularHoursTimer/MarketRegularHoursTimer';

const ContentByMarketStatus: FC<HotGappersContentProps> = ({
  isMarketHours,
  isTimerEnabled,
  timerValueAsString,
  ...listProps
}: HotGappersContentProps): JSX.Element => {
  if (!isMarketHours) {
    return <MarketRegularHoursTimer isEnabled={isTimerEnabled} timerValueAsString={timerValueAsString} />;
  }

  return <HotGappersList {...listProps} />;
};

export default ContentByMarketStatus;
